export const DEFAULT_SERVICE_APPS_DIR = "service-apps";
